import React from "react";

type HorizontalLineProps = {
  color: string;
  className?: string;
  style?: React.CSSProperties;
};

const HorizontalLine = (props: HorizontalLineProps) => {
  const { color, className, style } = props;
  let styleToInject;
  if (color) {
    styleToInject = { ...style, color };
  } else styleToInject = style;

  return <div className={`horizontal-Line ${color}`} style={styleToInject} />;
};

export default HorizontalLine;
